import '../index.scss';
import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, {Component} from 'react';
import {createErrorMessage, createSuccessMessage} from '../../shared/action-creator/alert-messages';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
//import CSVFile from '../../assets/corrected_part_number_template.csv';
import FileUploadPanel from './file-upload-panel';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {customizeErrorAlert} from '../../shared/services/customize-error-alert-bar';
import {showLoadingIndicator} from '../../shared/state/busy-counter';
import {uploadBatchFactoryData} from '../repositories';
import _ from 'lodash';
import { downloadSampleReports } from '../../claims/repositories';

class BatchCorrectedPartNoUploadPage extends Component {

    state = {
        fileInfo: {},
        uploadResp: {},
        // uploadStatus: '',
        isRefineWorklist: false
    }

    componentDidMount() {

        this.props.increaseCounter();
        setTimeout(() => {
            this.props.decreaseCounter();
        }, 500);

    }

    handleFileDrop = files => {
        console.log("handleFileDrop :", this.state.isChecked);
        this.setState({
            fileInfo: files[0],
        });

    }

    handleRejectedFiles = () => {

        this.props.increaseCounter();
        const msg = 'Only CSV files are allowed';
        customizeErrorAlert(msg);
        this.props.decreaseCounter();

    }

    handleSubmitClick = () => {
        this.setState({
            uploadResp: {},
            // uploadStatus: ''
        });

        let endPoint = "claims/corrected-part-number"

        this.props.increaseCounter();
        uploadBatchFactoryData(this.state.fileInfo, endPoint).then(response => {
            //console.log("response.status::", response.status);
            if (response.errors.length) {
                response.errors.forEach(element => {
                    customizeErrorAlert(element);
                });

            } else {
                 console.log("response.status::", response.uploadStatisticsMap);
                // if (response.skipClaims.length) {
                //     response.skipClaims.forEach(element => {
                //         customizeErrorAlert(element);
                //     });
                // }
                this.setState({
                    uploadResp: response
                });
                console.log("uploadResp", this.state.uploadResp);
                // this.props.createSuccessMessage( response.status );
            }
            this.props.decreaseCounter();

        }).catch(() => {
            this.props.decreaseCounter();
        });
    }

    handleCancleClick = () => {
        this.setState({
            fileInfo: {},
            uploadResp: {},
            // uploadStatus: '',
        });

    }

    handleCheckBoxClick = e => {

        this.state.isRefineWorklist === false ? this.state.isRefineWorklist = true
            : this.state.isRefineWorklist = false

    }

    onBtExport = () => {
       const { skipClaims } = this.state.uploadResp;

        if (!skipClaims) {
            alert("No skipped claims to export.");
            return;
        }

        const csvContent = "data:text/csv;charset=utf-8," + skipClaims.map(e => e).join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "skipped_claims.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
handleDownloadClick = (fileName) => () => {
        console.log("fileName", fileName);
        
        this.props.increaseCounter();

        downloadSampleReports(fileName)
            .then(response => {
                response.blob().then( blob => {

                    const url = window.URL.createObjectURL( blob );
                    const a = document.createElement( 'a' );
                    a.setAttribute( 'download', fileName+'.csv' );
                    a.href = url;
                    document.body.appendChild( a );
                    a.click();
                    a.parentNode.removeChild( a );
            
                } );
                this.props.decreaseCounter();
            })
            .catch(() => {
                this.props.decreaseCounter();
            });
    }

    render() {
        const containerStyle = {
            // marginTop: '1%',
            backgroundColor: 'white',
            border: '1px solid black',
            borderStyle: 'dotted',
            borderRadius: '4px',
            paddingLeft: '10px',
            marginLeft: '5px',
            marginRight: '5px',
            fontSize: '14px'
        };

        const valueStyleStart = {
            width: '2%',
            display: 'inline-block'
        };
        const valueStyleLeft = {
            width: '20%',
            display: 'inline-block',
            fontSize: '12px',
        };
        const valueStyleMiddle = {
            width: '3%',
            display: 'inline-block',
            fontSize: '12px',
            fontWeight:'bold'
        };
        const valueStyleRight = {
            width: '40%',
            display: 'inline-block',
            fontSize: '12px'
        };

        const valueStyleLeftListPP = {
            width: '75%',
            display: 'inline-block',
            fontSize: '12px'
        };
        const valueStyleLeftListContent = {
            width: '8%',
            display: 'inline-block',
            fontSize: '12px',
        };
        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter}/>
                <div className="massUpdate-page">
                    <div className="upload-label">
                        <h2>Upload Corrected Part Numbers</h2>
                    </div>
                    {/* <div className="sample-report">
                        <a title="Field having values can update only" href={CSVFile}
                           download="corrected_part_number_template.csv">Download Sample Report</a>
                    </div> */}

                    <div className="sample-report-analysis">
                    <a
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('corrected_part_number_template')}
                    >
                        Download Sample Report
                    </a>
                </div>
                    <FileUploadPanel
                        handleFileDrop={this.handleFileDrop}
                        handleRejectedFiles={this.handleRejectedFiles}
                        handleSubmitClick={this.handleSubmitClick}
                        handleCancleClick={this.handleCancleClick}
                        fileName={this.state.fileInfo.name}
                       /*  refineWorklist={"refineWorklist"}
                        isRefineWorklist={this.state.isRefineWorklist}
                        handleCheckBoxClick={this.handleCheckBoxClick} */

                    />
                </div>



                {
                    (!_.isEmpty(this.state.uploadResp)) ?
                        <div style={containerStyle}>
                            <span role="img" aria-label="image">{this.state.uploadResp.status} &#9989; </span>
                            {
                                Object.entries(this.state.uploadResp.uploadStatisticsMap).map(([key, value]) =>
                                    <small>
                                        <ul>
                                            <li style={valueStyleStart}>&#10004;</li>
                                            <li style={valueStyleLeft}>{key}</li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleRight}>{value} Records</li>
                                        </ul>
                                    </small>
                                )}

                            {
                                (!_.isEmpty(this.state.uploadResp.invalidPrimePartList)) ?
                                    <div>
                                        <hr></hr>
                                        <ul>
                                            <li style={valueStyleStart}>&#9888;</li>
                                            <li style={valueStyleLeft}><b>INVALID PRIMEPART NUMBER</b></li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleLeftListPP}>
                                                {this.state.uploadResp.invalidPrimePartList.length} Records
                                            </li>
                                            <li style={valueStyleStart}></li>
                                            {
                                                this.state.uploadResp.invalidPrimePartList.map((ppNumber) => (
                                                    <li style={valueStyleLeftListContent}>&bull; {ppNumber}</li>
                                                ))}
                                        </ul>

                                    </div> : null
                            }

{
                                (!_.isEmpty(this.state.uploadResp.unAuthorizedFactoryList)) ?
                                    <div>
                                        <hr></hr>
                                        <ul>
                                            <li style={valueStyleStart}>&#9888;</li>
                                            <li style={valueStyleLeft}>UNAUTHORIZED FACTORY</li>
                                            <li style={valueStyleMiddle}>&ndash;</li>
                                            <li style={valueStyleLeftListPP}>
                                                {this.state.uploadResp.unAuthorizedFactoryList.length} Records
                                            </li>
                                            <li style={valueStyleStart}></li>
                                            {
                                                this.state.uploadResp.unAuthorizedFactoryList.map((factoryCode) => (
                                                    
                                                    <li style={valueStyleLeftListContent}>&#9733; {factoryCode}</li>
                                                ))}
                                        </ul>

                                    </div> : null
                            }

{
                                (!_.isEmpty(this.state.uploadResp.skipClaims)) &&
                                <div>
                                    <hr />
                                    <ul>
                                        <li style={valueStyleStart}>&#9888;</li>
                                        <li style={valueStyleLeft}><b>SKIPPED CLAIMS</b></li>
                                        <li style={valueStyleMiddle}>&ndash;</li>
                                        <li style={valueStyleLeftListPP}>
                                            [{this.state.uploadResp.skipClaims.join(', ')}]
                                        </li>
                                        
                                        <li style={valueStyleStart}></li>
                                        <li style={valueStyleLeftListPP}>
                                            <button className="primary-button" onClick={this.onBtExport} type="button">
                                                <span> Export to CSV </span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            }

                        </div> : null
                }

            </section>
        );

    }

}

BatchCorrectedPartNoUploadPage.displayName = 'BatchCorrectedPartNoUploadPage';
BatchCorrectedPartNoUploadPage.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
    factories: state.application.factories.factories
});
const mapDispatchToProps = dispatch => ({
    increaseCounter: () => dispatch(busyCounter.increaseBusyCounter()),
    decreaseCounter: () => dispatch(busyCounter.decreaseBusyCounter()),
    createSuccessMessage: message => dispatch(createSuccessMessage(message)),
    createErrorMessage: message => dispatch(createErrorMessage(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BatchCorrectedPartNoUploadPage);
